import { createAction, props } from '@ngrx/store';

export enum UserAuthActions {
    setIsAuthenticated = '[user auth] set is authenticated',
}

export const SetIsAuthenticated = createAction(
    UserAuthActions.setIsAuthenticated,
    props<{ isAuthenticated: boolean }>()
);
